import { render, staticRenderFns } from "./FiltertronTraySection.vue?vue&type=template&id=53c75009&"
import script from "./FiltertronTraySection.vue?vue&type=script&lang=js&"
export * from "./FiltertronTraySection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports